import { useMemo } from "react";
import { useNotificationsForScreen } from "~/repository";

export function useUnreadCount(enabled = true) {
  const { data } = useNotificationsForScreen({
    enabled,
  });

  const unreadCount = useMemo(() => {
    if (data && Array.isArray(data.pages)) {
      return data.pages[0].total_unread;
    }
    return 0;
  }, [data]);

  return unreadCount;
}
